import React from "react";
import { Modal, Descriptions, Divider, Card, Row, Col, Typography } from "antd";
import {
    MailOutlined,
    PhoneOutlined,
    HomeOutlined,
    EnvironmentOutlined,
    NumberOutlined,
    UserOutlined,
    BankOutlined
} from "@ant-design/icons";

const { Title, Text } = Typography;

const FranchiseInfoModal = ({ open, onClose, franchiseInfo }) => {
    const businessInfo = franchiseInfo?.businessInfo || {};

    const renderValue = (value) =>
        value ? <Text strong>{value}</Text> : <Text type="secondary">Not provided</Text>;

    const hasBusinessInfo = businessInfo.businessName || businessInfo.primaryBusinessPhone || businessInfo.name;

    return (
        <Modal
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <UserOutlined style={{ color: '#AE0000' }} />
                    <span>Franchise Business Information</span>
                </div>
            }
            open={open}
            onCancel={onClose}
            footer={null}
            width={800}
        >
            {!hasBusinessInfo ? (
                <div style={{
                    textAlign: 'center',
                    padding: '40px 20px',
                    color: '#666'
                }}>
                    <BankOutlined style={{ fontSize: '48px', color: '#d9d9d9', marginBottom: '16px' }} />
                    <Title level={4} style={{ color: '#666', marginBottom: '8px' }}>
                        No Business Information
                    </Title>
                    <Text type="secondary">
                        This franchise has not yet added their business information.
                    </Text>
                </div>
            ) : (
                <div style={{ padding: '16px 0' }}>
                    {/* Basic Information */}
                    <Card
                        title={
                            <span>
                                    <HomeOutlined style={{ marginRight: 8, color: '#AE0000' }} />
                                Basic Information
                            </span>
                        }
                        size="small"
                        style={{ marginBottom: 16 }}
                    >
                        <Row gutter={[16, 16]}>
                                <Col span={24}>
                                    <div style={{ marginBottom: 16 }}>
                                        <Text type="secondary">Name</Text>
                                        <div>{renderValue(businessInfo.name)}</div>
                                    </div>
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]}>
                            <Col span={12}>
                                <div>
                                    <Text type="secondary">Business Name</Text>
                                    <div>{renderValue(businessInfo.businessName)}</div>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div>
                                    <Text type="secondary">Email</Text>
                                    <div>{renderValue(businessInfo.email)}</div>
                                </div>
                            </Col>
                        </Row>
                    </Card>

                    {/* Contact Information */}
                    <Card
                        title={
                            <span>
                                    <PhoneOutlined style={{ marginRight: 8, color: '#AE0000' }} />
                                Contact Information
                            </span>
                        }
                        size="small"
                        style={{ marginBottom: 16 }}
                    >
                        <Row gutter={[16, 16]}>
                            <Col span={12}>
                                <div>
                                    <Text type="secondary">Primary Phone</Text>
                                    <div>{renderValue(businessInfo.primaryBusinessPhone)}</div>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div>
                                    <Text type="secondary">Secondary Phone</Text>
                                    <div>{renderValue(businessInfo.secondaryBusinessPhone)}</div>
                                </div>
                            </Col>
                        </Row>
                    </Card>

                    {/* Address Information */}
                    <Card
                        title={
                            <span>
                                    <EnvironmentOutlined style={{ marginRight: 8, color: '#AE0000' }} />
                                Address Information
                            </span>
                        }
                        size="small"
                        style={{ marginBottom: 16 }}
                    >
                        <Row gutter={[16, 16]}>
                            <Col span={24}>
                                <div style={{ marginBottom: 16 }}>
                                    <Text type="secondary">Business Address</Text>
                                    <div>{renderValue(businessInfo.businessAddress)}</div>
                                </div>
                            </Col>
                            <Col span={8}>
                                <div>
                                    <Text type="secondary">City</Text>
                                    <div>{renderValue(businessInfo.city)}</div>
                                </div>
                            </Col>
                            <Col span={8}>
                                <div>
                                    <Text type="secondary">Province</Text>
                                    <div>{renderValue(businessInfo.province)}</div>
                                </div>
                            </Col>
                            <Col span={8}>
                                <div>
                                    <Text type="secondary">Postal Code</Text>
                                    <div>{renderValue(businessInfo.postalCode)}</div>
                                </div>
                            </Col>
                        </Row>
                    </Card>

                    {/* Tax Information */}
                    <Card
                        title={
                            <span>
                                    <NumberOutlined style={{ marginRight: 8, color: '#AE0000' }} />
                                Tax Information
                            </span>
                        }
                        size="small"
                            style={{ marginBottom: 16 }}
                    >
                        <Row gutter={[16, 16]}>
                            <Col span={12}>
                                <div>
                                    <Text type="secondary">GST Number</Text>
                                    <div>{renderValue(businessInfo.GST)}</div>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div>
                                    <Text type="secondary">PST Number</Text>
                                    <div>{renderValue(businessInfo.PST)}</div>
                                </div>
                            </Col>
                        </Row>
                    </Card>

                        {/* Bank Account Details */}
                        {businessInfo.bank && (
                            <Card
                                title={
                                    <span>
                                        <BankOutlined style={{ marginRight: 8, color: '#AE0000' }} />
                                        Bank Account Details
                                    </span>
                                }
                                size="small"
                            >
                                <Row gutter={[16, 16]}>
                                    <Col span={12}>
                                        <div>
                                            <Text type="secondary">Bank Name</Text>
                                            <div>{renderValue(businessInfo.bank?.name)}</div>
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div>
                                            <Text type="secondary">Account No.</Text>
                                            <div>{renderValue(businessInfo.bank?.account)}</div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                                    <Col span={12}>
                                        <div>
                                            <Text type="secondary">Transit No.</Text>
                                            <div>{renderValue(businessInfo.bank?.ifsc)}</div>
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div>
                                            <Text type="secondary">Institution No.</Text>
                                            <div>{renderValue(businessInfo.bank?.branch)}</div>
                                        </div>
                                    </Col>
                                </Row>
                            </Card>
                        )}
                </div>
            )}
        </Modal>
    );
};

export default FranchiseInfoModal; 